import { Lock, X } from "lucide-react";
import { Button } from "../ui/button";
import refurblyWhite from "@/assets/refurbly-white.svg";
import { resolveFlexSiteUrl } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

interface CheckoutLayoutProps {
  children: React.ReactNode;
}

export function CheckoutLayout({ children }: CheckoutLayoutProps) {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <>
      <div className="bg-primary">
        <div className="flex items-center justify-between px-5 md:px-16 py-2">
          <div className="basis-[100px]">
            <Button
              variant={"link"}
              className="text-white p-0"
              onClick={() => {
                window.location.href = resolveFlexSiteUrl("/", lang);
              }}
            >
              <X className="!h-3 !w-3 text-white -mr-1" />
              {t("layout.cancel")}
            </Button>
          </div>
          <img className="max-h-6" src={refurblyWhite} alt="Refurbly" />
          <div className="basis-[100px] flex items-center gap-1.5 text-white justify-end">
            <Lock className="h-4 w-4" />
            <span className="text-xs font-normal whitespace-nowrap">
              {t("securityHeader.trustedPayment")}
            </span>
          </div>
        </div>
      </div>
      <div className="min-h-screen flex flex-col animate-in fade-in duration-500 bg-background px-5 md:px-0">
        <div className="flex-1 flex items-center justify-center py-8">
          <div className="container max-w-2xl space-y-6">{children}</div>
        </div>
      </div>
    </>
  );
}
